export default __webpack_public_path__ + "static/media/delete.9ced48f0.svg";